/* =============================================================
   IMERSÃO — comportamento partilhado pelas secções lp-*.liquid
   Carregado uma única vez (o guard abaixo evita repetições,
   porque cada secção pede o mesmo <script src>).
   ============================================================= */
(function () {
  if (window.__lpImersaoInit) return;
  window.__lpImersaoInit = true;

  /* ---- entradas animadas -------------------------------------------------- */
  var observador = null;

  function animar(raiz) {
    var alvos = (raiz || document).querySelectorAll('.lp-imersao .js-anim:not(.is-visible)');
    if (!alvos.length) return;

    // Sem IntersectionObserver (ou com movimento reduzido), mostra tudo já.
    if (
      !('IntersectionObserver' in window) ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      alvos.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    if (!observador) {
      observador = new IntersectionObserver(
        function (entradas) {
          entradas.forEach(function (entrada) {
            if (!entrada.isIntersecting) return;
            entrada.target.classList.add('is-visible');
            observador.unobserve(entrada.target);
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -60px 0px' }
      );
    }
    alvos.forEach(function (el) { observador.observe(el); });
  }

  /* ---- vídeos dos "Momentos" ---------------------------------------------- */
  document.addEventListener('click', function (e) {
    var botao = e.target.closest('.lp-imersao .moment-play');
    if (!botao) return;

    var cartao = botao.closest('.moment-card');
    var video = cartao && cartao.querySelector('video');
    if (!video) return;

    // Pára os outros antes de arrancar com este.
    document.querySelectorAll('.lp-imersao .moment-card.is-playing').forEach(function (outro) {
      if (outro === cartao) return;
      var v = outro.querySelector('video');
      if (v) v.pause();
      outro.classList.remove('is-playing');
    });

    cartao.classList.add('is-playing');
    var p = video.play();
    if (p && p.catch) p.catch(function () { cartao.classList.remove('is-playing'); });
  });

  // Se o visitante usar os controlos nativos, mantém o estado coerente.
  document.addEventListener(
    'pause',
    function (e) {
      var cartao = e.target.closest && e.target.closest('.lp-imersao .moment-card');
      if (cartao) cartao.classList.remove('is-playing');
    },
    true
  );

  /* ---- arranque ------------------------------------------------------------ */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { animar(); });
  } else {
    animar();
  }

  // No editor de temas as secções são recarregadas sem refrescar a página.
  document.addEventListener('shopify:section:load', function (e) { animar(e.target); });
})();
